import { useEffect } from "react";
import { useMediaQuery } from "@material-ui/core";
import type { Theme } from "@material-ui/core";

type PreventBackModalProps = {
  open: boolean;
  disabled?: boolean;
  onClose: () => void;
};

export function usePreventBackModal({ open, disabled, onClose }: PreventBackModalProps): void {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  useEffect(() => {
    if (disabled) return;

    if (!open) return;

    if (!isMobile) return;

    preventBackButton();

    const handleBackButton = (): void => {
      if (!open) return;

      preventBackButton();

      onClose();
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.history.back();
      window.removeEventListener("popstate", handleBackButton);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, isMobile]);

  return;
}

function preventBackButton(): void {
  window.history.pushState(null, null, document.URL);
}
